export default function CsharpPolymorphism() {
  return (
    <h2>Csharp Polymorphism</h2>
  );
}
